import React from 'react';

import { Chip, Stack, Tooltip } from '@mui/material';

import { type PromoFeatureWithAccess } from '@luxuryescapes/contract-svc-promo';

import { getPromoFeatureAccessBadges } from './promoFeatureAccessBadges';

interface Props {
  feature: PromoFeatureWithAccess;
}

export default function PromoFeatureAccessChips({ feature }: Props) {
  const badges = getPromoFeatureAccessBadges(feature);
  if (!badges.length) {
    return null;
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5} aria-label={`${feature.displayName} access`}>
      {badges.map((badge) => (
        <Tooltip key={`${badge.label}:${badge.description}`} title={badge.description}>
          <Chip
            size="small"
            variant="outlined"
            color={badge.kind === 'optIn' ? 'warning' : 'default'}
            label={badge.label}
            aria-label={badge.description}
          />
        </Tooltip>
      ))}
    </Stack>
  );
}
